import React from 'react';
import TrashCan from '@uber/base-icons/trash-can';
import { ActionButton } from './action-button';
import { ICON_SIZE } from './constants';
type PropsT = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  size?: number;
};
export function DeleteButton({
  onClick,
  size = ICON_SIZE
}: PropsT) {
  return <ActionButton icon={<TrashCan size={size} />} name="Delete all annotations" onClick={onClick} />;
}